export default "__VITE_ASSET__93918ffd__"